import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isBrowser as m, hasInstance as d } from "./utils.js";
import { on as p, off as g } from "../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { onBeforeMount as h, onBeforeUnmount as k } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { readonly as r, ref as f } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const t = f(null);
function u(e) {
  if (e.clientX > 0 || e.clientY > 0)
    t.value = {
      x: e.clientX,
      y: e.clientY
    };
  else {
    const { target: o } = e;
    if (o instanceof Element) {
      const { left: i, top: l, width: s, height: a } = o.getBoundingClientRect();
      i > 0 || l > 0 ? t.value = {
        x: i + s / 2,
        y: l + a / 2
      } : t.value = { x: 0, y: 0 };
    } else
      t.value = null;
  }
}
let n = 0, c = !0;
function w() {
  if (!m)
    return r(f(null));
  n === 0 && p("click", document, u, !0);
  const e = () => {
    n += 1;
  };
  return c && (c = d()) ? (h(e), k(() => {
    n -= 1, n === 0 && g("click", document, u, !0);
  })) : e(), r(t);
}
export {
  w as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-click-position.js
// module id = 986
// module chunks = 67